import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useLang } from "@/i18n";
import { TrialBalance } from "@/components/ledger/TrialBalance";
import { AccountLedger } from "@/components/ledger/AccountLedger";
import { ChartOfAccounts } from "@/components/ledger/ChartOfAccounts";
import { Journal } from "@/components/ledger/Journal";

export default function Ledger() {
  const { t } = useLang();
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get("account") ? "ledger" : "balance");
  const openLedger = (code) => { setParams({ account: code }); setTab("ledger"); };

  return (
    <div className="space-y-5 page-enter" data-testid="ledger-page">
      <p className="text-xs text-slate-500">{t("ledger_hint")}</p>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-slate-100 dark:bg-slate-800">
          <TabsTrigger value="balance" data-testid="ledger-tab-balance">{t("trial_balance")}</TabsTrigger>
          <TabsTrigger value="ledger" data-testid="ledger-tab-ledger">{t("general_ledger")}</TabsTrigger>
          <TabsTrigger value="accounts" data-testid="ledger-tab-accounts">{t("chart_of_accounts")}</TabsTrigger>
          <TabsTrigger value="journal" data-testid="ledger-tab-journal">{t("journal")}</TabsTrigger>
        </TabsList>
        <TabsContent value="balance" className="mt-5"><TrialBalance onOpenAccount={openLedger} /></TabsContent>
        <TabsContent value="ledger" className="mt-5"><AccountLedger initialCode={params.get("account") || ""} /></TabsContent>
        <TabsContent value="accounts" className="mt-5"><ChartOfAccounts onOpenAccount={openLedger} /></TabsContent>
        <TabsContent value="journal" className="mt-5"><Journal /></TabsContent>
      </Tabs>
    </div>
  );
}
